// Phone normalisation + messaging deep links
export function normalizePhone(phone, countryCode) {
  const cc = String(countryCode || "").replace(/\D/g, "");
  let digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return "";
  if (String(phone).trim().startsWith("+")) return digits;
  if (digits.startsWith("00")) return digits.slice(2);
  if (digits.startsWith("0")) return cc + digits.slice(1);
  if (cc && digits.startsWith(cc) && digits.length > 9) return digits;
  return cc + digits;
}

export const whatsappUrl = (phone, countryCode, text) => {
  const number = normalizePhone(phone, countryCode);
  const base = number ? `https://wa.me/${number}` : "https://wa.me/";
  return `${base}?text=${encodeURIComponent(text)}`;
};

export const WECHAT_SCHEME = "weixin://";
